import { HighFeeWarning } from 'modules/tradeWidgetAddons'

// TODO: Add proper return type annotation
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function Warnings() {
  return (
    <>
      <HighFeeWarning />
    </>
  )
}
